module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n/**\n * This block destructures the local variables for use within this ejs template.\n */\n  var functionName = locals.functionName;\n  var binary = locals.binary;\n  var enabledEncodings = locals.enabledEncodings;\n  var chunkSize = locals.chunkSize;\n  var showReadWireButton = locals.showReadWireButton;\n%>\n<%\n  var i18n = require(\'@cdo/netsim/locale\');\n  var NetSimConstants = require(\'./NetSimConstants\');\n  var DataConverters = require(\'./DataConverters\');\n\n  var getEncodingLabel = require(\'./NetSimUtils\').getEncodingLabel;\n\n  var EncodingType = NetSimConstants.EncodingType;\n  var PacketUIColumnType = NetSimConstants.PacketUIColumnType;\n\n  /**\n   * @param {EncodingType} encodingType\n   * @param {string} encodedContent\n   */\n  function logRow(encodingType, encodedContent) {\n    %>\n    <tr class="<%= encodingType %>">\n      <th nowrap class="<%= PacketUIColumnType.ENCODING_LABEL %>"><%= getEncodingLabel(encodingType) %></th>\n      <td class="<%= PacketUIColumnType.MESSAGE %>"><%= encodedContent %></td>\n    </tr>\n    <%\n  }\n%>\n<div class="scroll-area bit-log-scroll-area">\n  <div class="packet">\n    <table>\n      <tbody>\n        <%\n          logRow(EncodingType.ASCII, DataConverters.binaryToAscii(binary, chunkSize));\n\n          logRow(EncodingType.DECIMAL, DataConverters.alignDecimal(DataConverters.binaryToDecimal(binary, chunkSize)));\n\n          logRow(EncodingType.HEXADECIMAL, DataConverters.formatHex(DataConverters.binaryToHex(binary), chunkSize));\n\n          logRow(EncodingType.BINARY, DataConverters.formatBinary(binary, chunkSize));\n\n          logRow(EncodingType.A_AND_B, DataConverters.formatAB(DataConverters.binaryToAB(binary), chunkSize));\n        %>\n      </tbody>\n    </table>\n  </div>\n  <% if (showReadWireButton) { %>\n    <div class="panel-footer bit-log-panel-footer">\n      <div class="right-side-controls">\n        <span class="netsim-button large-button" id="read-wire-button"><%= i18n.readWire() %></span>\n      </div>\n    </div>\n  <% } %>\n</div>\n', __filename = "src/netsim/NetSimBitLogPanel.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var functionName = locals.functionName;
        var binary = locals.binary;
        var enabledEncodings = locals.enabledEncodings;
        var chunkSize = locals.chunkSize;
        var showReadWireButton = locals.showReadWireButton;
        __line = 10;
        __append("\n");
        __line = 11;
        var i18n = require("@cdo/netsim/locale");
        var NetSimConstants = require("./NetSimConstants");
        var DataConverters = require("./DataConverters");
        var getEncodingLabel = require("./NetSimUtils").getEncodingLabel;
        var EncodingType = NetSimConstants.EncodingType;
        var PacketUIColumnType = NetSimConstants.PacketUIColumnType;
        function logRow(encodingType, encodedContent) {
            __line = 26;
            __append('\n    <tr class="');
            __line = 27;
            __append(escapeFn(encodingType));
            __append('">\n      <th nowrap class="');
            __line = 28;
            __append(escapeFn(PacketUIColumnType.ENCODING_LABEL));
            __append('">');
            __append(escapeFn(getEncodingLabel(encodingType)));
            __append('</th>\n      <td class="');
            __line = 29;
            __append(escapeFn(PacketUIColumnType.MESSAGE));
            __append('">');
            __append(escapeFn(encodedContent));
            __append("</td>\n    </tr>\n    ");
            __line = 31;
        }
        __line = 33;
        __append('\n<div class="scroll-area bit-log-scroll-area">\n  <div class="packet">\n    <table>\n      <tbody>\n        ');
        __line = 38;
        logRow(EncodingType.ASCII, DataConverters.binaryToAscii(binary, chunkSize));
        logRow(EncodingType.DECIMAL, DataConverters.alignDecimal(DataConverters.binaryToDecimal(binary, chunkSize)));
        logRow(EncodingType.HEXADECIMAL, DataConverters.formatHex(DataConverters.binaryToHex(binary), chunkSize));
        logRow(EncodingType.BINARY, DataConverters.formatBinary(binary, chunkSize));
        logRow(EncodingType.A_AND_B, DataConverters.formatAB(DataConverters.binaryToAB(binary), chunkSize));
        __line = 48;
        __append("\n      </tbody>\n    </table>\n  </div>\n  ");
        __line = 52;
        if (showReadWireButton) {
            __append('\n    <div class="panel-footer bit-log-panel-footer">\n      <div class="right-side-controls">\n        <span class="netsim-button large-button" id="read-wire-button">');
            __line = 55;
            __append(escapeFn(i18n.readWire()));
            __append("</span>\n      </div>\n    </div>\n  ");
            __line = 58;
        }
        __append("\n</div>\n");
        __line = 60;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}